import { Divider, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import MDTypography from "components/MDTypography";
import { getReturnOrderWebApiLog } from "services/data.outbound.service";

const columns = [
  { label: "SKU Code", id: "skuCode" },
  { label: "Order Quantity", id: "orderQuantity" },
  { label: "Cancel Quantity", id: "cancelQuantity" },
  { label: "Remaining Quantity", id: "remainingQuantity" },
  { label: "Tracking Number", id: "trackingNumber" },
  { label: "Carrier", id: "carrier" },
  { label: "Created By", id: "createdBy" },
  { label: "Created On", id: "createdOn" },
];

function ReturnOrderWebApiLog({ open, setOpen, logRequest, setLogRequest }) {
  const { data } = useQuery({
    queryKey: ["return-order-webapi-log", { logRequest }],
    queryFn: () => getReturnOrderWebApiLog(logRequest),
    enabled: Boolean(logRequest),
  });

  const item = data?.data.data;

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Return Order
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(item) && (
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={3}>
                <b>Customer Code : </b>
                {item.customerCode}
              </Grid>
              <Grid item xs={3}>
                <b>Customer Order Number : </b>
                {item.custOrdNbr}
              </Grid>
              <Grid item xs={3}>
                <b>Return Number : </b>
                {item.returnNumber}
              </Grid>
              <Grid item xs={3}>
                <b>Order Number : </b>
                {item.orderNumber}
              </Grid>
              <Grid item xs={3}>
                <b>Tracking Number : </b>
                {item.trackingNumber}
              </Grid>
              <Grid item xs={3}>
                <b>Carrier : </b>
                {item.carrier}
              </Grid>
              <Grid item xs={3}>
                <b>Order Quantity : </b>
                {item.orderQuantity}
              </Grid>
              <Grid item xs={3}>
                <b>Cancel Quantity : </b>
                {item.cancelQuantity}
              </Grid>
              <Grid item xs={3}>
                <b>Created By : </b>
                {item.createdBy}
              </Grid>
              <Grid item xs={3}>
                <b>Created On : </b>
                {item.createdOn}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.details} />
          </div>
        </>
      )}
    </Drawer>
  );
}

export default ReturnOrderWebApiLog;
